import * as types from './action-types'

function handleErrors(res) {
  if (!res.ok) throw Error(res.statusText)
  return res
}

const requestHero = () => ({
  type: types.REQUEST_HERO
})

const receiveHero = data => ({
  type: types.RECEIVE_HERO,
  payload: {
    data,
    receivedAt: Date.now()
  }
})

const errorHero = () => ({
  type: types.ERROR_HERO
})


var cachedFetch 

export const fetchHero = () => dispatch => {
  dispatch(requestHero())
  return cachedFetch || (
    cachedFetch = fetch('/api/hero')
    .then(handleErrors)
    .then(res => res.json())
    .then(json => dispatch(receiveHero(json)))
    .catch(e => dispatch(errorHero(e)))
  )
}



// WEBPACK FOOTER //
// ./src/components/hero/actions.js